import { createMuiTheme } from "@material-ui/core";
import { BODY_FONT, HEADING_FONT } from "../common/styles/fonts";
import { convertArrayToObject } from "../common/utils";

const poppinsFontTypography = convertArrayToObject(["h1", "h2", "h3", "h4", "h5", "h6"], {
    fontFamily: HEADING_FONT,
});
const questrialFontTypography = convertArrayToObject(
    ["subtitle1", "subtitle2", "body1", "body2", "button", "caption", "overline"],
    { fontFamily: BODY_FONT },
);

const theme = createMuiTheme({
    typography: {
        fontFamily: `${HEADING_FONT}, ${BODY_FONT}`,
        ...poppinsFontTypography,
        ...questrialFontTypography,
    },
    components: {
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
        },
    },
});

export default theme;
